import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Button,
  CircularProgress,
  Grid,
  FormHelperText,
  Card,
} from '@mui/material';
import BenefitCard from './Components/BenefitCard';
import { toast } from 'react-toastify';
import BeneficiaryOCRForm from './Components/BeneficiaryOCRForm';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getInsuranceDetails,
  getUpdatedReationAction,
  AddBeneficiaryNomineeAction,
} from './APIs/action';
import { UserFileDict } from '../../../utils/settings';
import AgeWarningModal from './Components/AgeWarningModal';
import { FirmOwnershipType, InsuranceType } from './constants';
import FirmDetails from './Components/FirmDetails';
import { useSelector, useDispatch } from 'react-redux';
import {
  resetBeneficiaryData,
  setBeneficiaryData,
  updateBeneficiaryField,
} from './reducer/beneficiaryReducer';
import ExistingBeneficiaryCard from './Components/ExistingBeneficiaryCard';
import { CustomButton, CustomSelect } from '../../MUI_custom_component';

const AddBeneficiary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const insuranceType = location?.state?.insurance_type;
  const selectedCompanyEntity = location?.state?.selectedCompanyEntity;
  const isEdit = location?.state?.isEdit;
  const [insuranceData, setInsuranceData] = useState({
    existing_beneficiaries: [],
    benefit_card: null,
    selected_firm: [],
    owner_list: [],
    owner_type_text: null,
    relations: [],
    confirmation_text: ''
  });
  
  const {
    benefit_card,
    selected_firm,
    owner_list,
    owner_type_text,
    relations,
    confirmation_text,
  } = insuranceData;

  const [showAgeModal, setShowAgeModal] = useState(false);
  const [relationList, setRelationList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [updateRelation, setUpdateRelation] = useState(false);
  const [showAddNewForm, setShowAddNewForm] = useState(false);
  const [showExistingBeneficiaries, setShowExistingBeneficiaries] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState('AADHAAR');
  const [resetTrigger, setResetTrigger] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const beneficiary = useSelector((state) => state?.beneficiaryReducer?.beneficiaryData || {
    insurance_id: insuranceType,
    firm_owner_name: '',
    id_type: UserFileDict.PAN_CARD,
    id_number: '',
    id_str_base64: null,
    full_name: '',
    dob: '',
    age: '',
    phone_number: '',
    relation: '',
    confirm: false,
    firm_type: owner_type_text?.value || '',
    gender: '',
  });
  const showHistory = useSelector(state => state.entityReducer.show_history);
  

  useEffect(() => {
    if (!beneficiary.insurance_id && insuranceType) {
      dispatch(setBeneficiaryData({
        insurance_id: insuranceType,
        firm_owner_name: '',
        id_type:'',
        full_name: '',
        dob: '',
        age: '',
        phone_number: '',
        relation: '',
        confirm: false,
        firm_type: owner_type_text?.value || '',
        gender: '',
      }));
    }
  }, [insuranceType, beneficiary.insurance_id, owner_type_text, dispatch]);
  
  const getAllInsuranceDetails = async () => {
    setLoader(true);
    const { data, error, message } = await getInsuranceDetails(insuranceType, selectedCompanyEntity);
    setLoader(false);
    if (!error) {
      setInsuranceData(data);
    } else {
      toast.error(message);
    }
  };
  const handleSubmit = async (formData) => {
    const finalBeneficiaryData = {
      ...beneficiary,
      ...formData,
      firm_type: owner_type_text?.value || '',
      confirm: true
    };
    dispatch(setBeneficiaryData(finalBeneficiaryData));
    if (insuranceType === InsuranceType.LIFE_INSURANCE) {
      navigate('/beneficiary/add-nominee', {
        state: {
          insuranceData: insuranceData,
          insurance_type: insuranceType,
          selectedCompanyEntity: selectedCompanyEntity
        },
      });
    } else if (insuranceType === InsuranceType.MEDICAL_INSURANCE) {
      // Submit API call for Medical Insurance
      setSubmitLoader(true);
      const medicalInsurancePayload = {
        company_esi_id: selectedCompanyEntity,
        insurance_id: insuranceType,
        firm_owner_name: finalBeneficiaryData?.firm_owner_name || '',
        firm_type: finalBeneficiaryData?.firm_type || '',
        beneficiary: {
          // ...(finalBeneficiaryData?.ocr_verified && {
          //   id_type: finalBeneficiaryData?.id_type || '',
          //   id_number: finalBeneficiaryData?.id_number || '',
          // }),
          id_type: finalBeneficiaryData.ocr_verified ? finalBeneficiaryData?.id_type : null,
          id_number: finalBeneficiaryData?.id_number || null,
          full_name: finalBeneficiaryData?.full_name || '',
          gender: finalBeneficiaryData?.gender || '',
          dob: finalBeneficiaryData?.dob || '',
          age: finalBeneficiaryData?.age || 0,
          phone_number: finalBeneficiaryData?.phone_number || '',
          relation: finalBeneficiaryData?.relation || 'SELF',
          ocr_verified: finalBeneficiaryData?.ocr_verified || false
        }
      };

      const { error, message } = await AddBeneficiaryNomineeAction(medicalInsurancePayload);
      setSubmitLoader(false);

      if (!error) {
        toast.success(message || 'Beneficiary added successfully');
        navigate('/beneficiary/detail', {
          state: {
            insurance_type: insuranceType,
            selectedCompanyEntity: selectedCompanyEntity
          },
        });
      } else {
        toast.error(message || 'Failed to add beneficiary');
      }
    } else {
      navigate('/beneficiary', {
        state: {
          selectedCompanyEntity: selectedCompanyEntity
        },
      });
    }
  };
  
  const handleRelationUpdate = (newRelations) => {
    setRelationList(newRelations);
    if (newRelations && newRelations.length > 0) {
      dispatch(updateBeneficiaryField('relation', newRelations[0].value));
    }
  };
  
  useEffect(() => {
    if (relations?.length) {
      setRelationList(relations);
      if (!beneficiary.relation && relations.length > 0) {
        dispatch(updateBeneficiaryField('relation', relations[0].value));
      }
    }
  }, [relations]); 
  useEffect(() => {
    if (!beneficiary.relation && relationList.length > 0) {
      dispatch(updateBeneficiaryField('relation', relationList[0].value));
    }
  }, [beneficiary.relation, relationList, dispatch]);

  useEffect(() => {
    if (insuranceType) {
      getAllInsuranceDetails();
    } else {
      navigate('/beneficiary');
    }
  }, [insuranceType]);
  const callBloodRelationAPI = async (firm_type, fromEdit = false) => {
    const { error, message, data } = await getUpdatedReationAction(firm_type);
    if (!error) {
      setRelationList(data);
      setUpdateRelation(true);
      // if (!fromEdit) {
      //   handleCloseAgeModal();
      // }
      if (data && data.length > 0) {
        dispatch(updateBeneficiaryField('relation', data[0].value));
      }
    } else {
      setUpdateRelation(false);
      toast.error(message);
    }
  };
  const handleCloseAgeModal = () => {
    setShowAgeModal(false);
  };
  useEffect(() => {
    dispatch(resetBeneficiaryData())
  }, []);
  const handleAddNewClick = () => {
    setShowAddNewForm(true);
  };
  const handleChooseExistingClick = () => {
    setShowAddNewForm(false);
    setShowExistingBeneficiaries(true);
  };
  useEffect(() => {
    if (!isEdit && owner_list?.length && !beneficiary.firm_owner_name) {
      dispatch(updateBeneficiaryField('firm_owner_name', owner_list[0].value));
    }
  }, [owner_list]);
  useEffect(() => {
    if (beneficiary.firm_owner_name) {
      dispatch(setBeneficiaryData({
        ...beneficiary,
        id_number: '',
        confirm: false,
        // Preserve OCR extracted data when firm owner changes
      }));
    }
  }, [beneficiary.firm_owner_name]);

  // Auto-select PAN when relation is "self", otherwise default to AADHAAR
  useEffect(() => {
    if (beneficiary.relation === 'self') {
      setSelectedDocumentType('PAN');
    } else if (beneficiary.relation && beneficiary.relation !== 'self') {
      setSelectedDocumentType('AADHAAR');
    }
  }, [beneficiary.relation]);

  // Handle document type change and reset OCR data
  const handleDocumentTypeChange = (documentType) => {
    setSelectedDocumentType(documentType);
    
    // Reset OCR-related fields when document type changes
    dispatch(setBeneficiaryData({
      ...beneficiary,
      id_number: '',
      full_name: '',
      dob: '',
      age: '',
      gender: '',
      confirm: false
    }));
    
    // Increment resetTrigger to reset OCR component
    setResetTrigger(prev => prev + 1);
  };

  
  return (
    <Box
      sx={{ p: { xs: 1.5, md: 3 }, borderRadius: 2 }}
    >
      {!loader ? (
        <Box sx={{ mb: { xs: 2, md: 3 } }}>
          <Grid
            container
            spacing={2}
            sx={{ alignItems: 'stretch', mb: 2 }}
          >
            <Grid
              item
              xs={12}
              sm={6}
            >
              <BenefitCard
                item={benefit_card}
                sx={{ height: '100%' }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <Card sx={{
                  boxShadow: 'none',
                  p: 2, 
                  borderRadius: 2,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-evenly',
               }}>
                {selected_firm &&
                  selected_firm.map((detail, i) => (
                    <React.Fragment key={i}>
                      <FirmDetails detail={detail} />
                    </React.Fragment>
                  ))}
              </Card>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <CircularProgress
            size={24}
            sx={{ color: '#995A00' }}
          />
        </Box>
      )}
      {!showExistingBeneficiaries &&  (
        <Box sx={{ p: 2, mb: 2, border: '1px solid #E0E0E0', borderRadius: 2 }}>
          {showAddNewForm || insuranceData?.existing_beneficiaries?.length === 0 || isEdit ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 3, md: 3 }, }}>
              <Grid
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                >
                  <Typography
                    variant='h2'
                    sx={{ mb: 1 }}
                  >
                    {owner_type_text?.label}
                  </Typography>

                  {owner_list && owner_list.length > 1 ? (
                    <CustomSelect
                      size="small"
                      width={'100%'}
                      value={
                        beneficiary.firm_owner_name ||
                        owner_list[0]?.value ||
                        ''
                      }
                      onChange={(e) =>
                        dispatch(updateBeneficiaryField('firm_owner_name', e.target.value))
                      }
                      error={!!errors.firm_owner_name}
                    >
                      {owner_list.map((owner) => (
                          <MenuItem
                            key={owner.value}
                            value={owner.value}
                          >
                            {owner.label}
                          </MenuItem>
                        ))}
                    </CustomSelect>
                  ) : (
                    <Typography
                      variant='body1'
                      sx={{ 
                        color: '#8C8C8C'
                      }}
                    >
                      {owner_list?.[0]?.label}
                    </Typography>
                  )}
                </Grid>
              </Grid>

              <BeneficiaryOCRForm
                beneficiary={beneficiary}
                onFieldChange={(field, value) => {
                  if (typeof field === 'object') {
                    dispatch(setBeneficiaryData({ ...beneficiary, ...field }));
                  } else {
                    dispatch(updateBeneficiaryField(field, value));
                  }
                }}
                relations={relationList}
                errors={errors}
                onSubmit={handleSubmit}
                confirmation_text={confirmation_text}
                selectedDocumentType={selectedDocumentType}
                resetTrigger={resetTrigger}
                onDocumentTypeChange={handleDocumentTypeChange}
                owner_type_text={owner_type_text}
                onRelationUpdate={handleRelationUpdate}
              />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, md: 2 }, }}>
              <Typography
                variant='h2'
              >
                Add Beneficiary Details
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <CustomButton
                  variant="filled"
                  color="primary"
                  label="Choose Existing"
                  onClick={handleChooseExistingClick}
                  sx={{ width: {xs: '100%', md: 'auto'} }}
                />
                <Typography variant='body1'>or</Typography>
                <CustomButton
                  variant="outlined"
                  color="primary"
                  label="Add New"
                  disabled={showHistory}
                  onClick={handleAddNewClick}
                  sx={{ width: {xs: '100%', md: 'auto'} }}
                />
              </Box>
            </Box>
          )}
        </Box>
      )}
      {showExistingBeneficiaries && !showAddNewForm && (
        <>
          {!loader && (
            <Grid
              spacing={2}
            >
              {insuranceData?.existing_beneficiaries?.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  key={index}
                >
                  <ExistingBeneficiaryCard
                    selectedCompanyEntity={selectedCompanyEntity}
                    beneficiary={item}
                    benefitType={insuranceType}
                    owner_type_text={owner_type_text}
                    handleSubmit={handleSubmit}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}
      <AgeWarningModal
        updateRelation={updateRelation}
        showAgeModal={showAgeModal}
        close={handleCloseAgeModal}
        callBloodRelationAPI={callBloodRelationAPI}
        owner_type_text={owner_type_text}
      />
    </Box>
  );
};

export default AddBeneficiary;
